import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import {
  Checkbox,
  type ICheckboxProps,
} from "@components/inputs/Checkbox/Checkbox";

type TFormInputProps<T extends FieldValues> = ICheckboxProps &
  UseControllerProps<T>;

export const FormCheckbox = <T extends FieldValues>({
  name,
  control,
  ...rest
}: TFormInputProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <Checkbox
      {...rest}
      {...fieldRest}
      checked={field.value}
      ref={fieldRef}
      error={error?.message}
      {...(rest.disabled ? { disabled: true } : {})}
    />
  );
};
